import axios from 'axios'
import Cookies from 'js-cookie'
import { message } from 'ant-design-vue'
// import errorCode from '@/utils/errorCode'
import router from '@/router'

// 超时时间：原来是 50s，一次失败就要用户干等 50 秒。
// 15s 足够覆盖普通接口；已知较慢的聚合接口在 api 层单独放宽（见 api/statistics.js 的 SLOW_TIMEOUT）。
const DEFAULT_TIMEOUT = 50000

const service = axios.create({
  // API 基础地址说明：
  // - Web 版：保持 '/api' 相对路径，由 devServer/nginx 代理转发
  // - 移动端 APK（npm run build:mobile）：.env.mobile 注入 VUE_APP_API_BASE，
  //   APK 无法走代理，需直连后端绝对地址，例如 http://47.108.56.90:8068
  baseURL: process.env.VUE_APP_API_BASE || '/api',
  timeout: DEFAULT_TIMEOUT,
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token') || Cookies.get('token')

    if (token) {
      config.headers['authorization'] = `Bearer ${token}`
    }
    // config.signal 由调用方传入（页面切走时 abort），axios 原生支持，这里不做改写
    return config
  },
  error => {
    console.error('请求错误：', error)
    return Promise.reject(error)
  }
)

// 判断是否为主动取消（切页 / 请求池关闭），这类错误不提示用户
const isCanceled = error =>
  axios.isCancel(error) ||
  error?.code === 'ERR_CANCELED' ||
  error?.name === 'CanceledError' ||
  error?.name === 'AbortError'

// 模块作用域拿不到 vue-router 实例时会 push 失败并二次抛错，统一兜底
const redirectToLogin = () => {
  try {
    if (router && typeof router.push === 'function') {
      router.push('/login')
      return
    }
  } catch (e) {
    console.error('跳转登录页失败：', e)
  }
  window.location.hash = '#/login'
}

// 响应拦截器
service.interceptors.response.use(
  response => {
    const body = response.data || {}
    const code = body.code
    const msg = body.msg || body.message

    if (code == 401) {
      //  token过期，同账号退出登录，
      localStorage.clear()
      message.error(msg || '登录已过期，请重新登录')
      redirectToLogin()
    } else if (code === 500) {
      message.error(msg || '服务异常，请稍后重试')
      redirectToLogin()
    }
    // else if (code !== 200) {
    //   message.error({ title: msg })
    // }
    return body

  },
  error => {
    // 主动取消（切页、请求池关闭）不提示，也不当作失败
    if (isCanceled(error)) {
      return Promise.reject(error)
    }

    // 静默模式：调用方自己处理错误（统计页按面板显示"加载失败 + 重试"）
    if (error.config?.silent) {
      return Promise.reject(error)
    }

    // 注意：超时 / 断网时 error.response 是 undefined，
    // 原写法直接读 error.response.data 会在拦截器里抛出二次异常，把真实原因吞掉
    const status = error.response?.status
    const serverMsg = error.response?.data?.message || error.response?.data?.msg

    let msg = serverMsg
    if (!msg) {
      if (error.code === 'ECONNABORTED' || /timeout/i.test(error.message || '')) {
        msg = '请求超时，请稍后重试'
      } else if (error.response) {
        msg = `请求失败（${status}）`
      } else if (error.request) {
        msg = '服务器无响应，请检查网络连接'
      } else {
        msg = '请求配置错误'
      }
    }

    message.error(msg)
    return Promise.reject(error)
  }
)

export default service
